export const supportsCSSVars =
  window.CSS && CSS.supports('color', 'var(--primary)');
